export const MAP_GEOFENCES_UNITS_SEARCH = "MAP_GEOFENCES_UNITS_SEARCH";
export const MAP_GEOFENCES_UNITS_SEARCH_RESPONSE = "MAP_GEOFENCES_UNITS_SEARCH_RESPONSE";